import { useRemoteResource } from "hooks/useRemoteResource";
import withRouter from "hoc/withRouter";
import { CircularProgress } from "@mui/material";
import ListPage from "components/ListPage/ListPage";
import offersSAService from "services/superadmin/offersSAService";
import ProductCardSuperAdmin from "components/ProductCard/ProductCardSuperAdmin";

const SuperAdminProductList = () => {
    const [data, loadData, loading, error] = useRemoteResource(offersSAService.getAll, "");

    function buildContent() {
        if (error) {
            return <div>{error}</div>
        }
        if (loading) {
            return <div className="text-center"><CircularProgress></CircularProgress></div>
        }
        if (data.rows.length === 0) {
            return <div>Товары отсутсвуют.</div>
        }
        if (data.rows.length > 0) {
            return data.rows.map((o, inx) => {
                return <div key={inx} className="m-b-16">
                    <ProductCardSuperAdmin offer={o} loadData={loadData}></ProductCardSuperAdmin>
                </div>
            })
        }
    }
    return (
        <ListPage pageTitle="Список товаров">
            <div className="m-t-32">
                {buildContent()}
            </div>
        </ListPage>

    );
};

export default withRouter(SuperAdminProductList);
